import React from 'react';
import {
  Box, Container, Typography, IconButton, Button, Stack,
} from '@mui/material';
import {
  Icons,
} from '@marageti/z4-lib';
import { Link } from 'react-router-dom';
import InfinitePartnersList from '../../components/infinite-partner-list';

const PartnersView = () => (
  <Container maxWidth="xl">
    <Box py={3}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography component="h1" variant="h2">
          Partners
        </Typography>
        <Button
          variant="contained"
          component={Link}
          to="add-partner"
          role="button"
          sx={{
            minWidth: 'fit-content',
            display: { xs: 'none', md: 'block' },
          }}
        >
          Add Partner
        </Button>
        <IconButton
          component={Link}
          to="add-partner"
          sx={{ display: { xs: 'block', md: 'none' } }}
        >
          <Icons.PlusCircleOutlined color="primary" />
        </IconButton>
      </Stack>
      <InfinitePartnersList />
    </Box>
  </Container>
);

export default PartnersView;
